import { useParams } from 'react-router-dom';

const SUPPORTED_LOCALES = ['ar', 'en'] as const;
export type Locale = (typeof SUPPORTED_LOCALES)[number];

export function useLocale(): Locale {
    const params = useParams<{ locale: string }>();
    const locale = params?.locale;
    const validLocale = locale && SUPPORTED_LOCALES.includes(locale as Locale) ? (locale as Locale) : 'ar';
    return validLocale;
}

export function useLocalizedPath() {
    const locale = useLocale();
    return (path = '', options?: { search?: string; hash?: string }) => {
        const cleanPath = path.replace(/^\//, '');
        const base = cleanPath ? `/${locale}/${cleanPath}` : `/${locale}`;
        const search = options?.search ? (options.search.startsWith('?') ? options.search : `?${options.search}`) : '';
        const hash = options?.hash ? (options.hash.startsWith('#') ? options.hash : `#${options.hash}`) : '';
        return `${base}${search}${hash}`;
    };
}
